<form [formGroup]="form" class="flex flex-col">
    <mat-accordion>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title
                    class="!text-tertiary-900 font-normal text-xl py-2"
                >
                    <h3 class="!text-tertiary-900 font-normal !text-xl !m-0">
                        General Information
                    </h3>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <hr class="mb-4" />

            <div
                class="flex flex-col w-full pl-4 md:pl-8 xl:w-10/12 2xl:w-8/12"
            >
                @if (isIndividualCoresRegistrationType) {
                    <div class="w-full xl:w-6/12">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Salutation</mat-label>
                            <mat-select formControlName="salutation">
                                @for (
                                    option of salutationOptions;
                                    track option.value
                                ) {
                                    <mat-option [value]="option.value">
                                        {{ option.label }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div
                        class="w-full flex flex-wrap xl:space-y-0 xl:grid xl:grid-cols-12 xl:gap-4"
                    >
                        <div class="w-full xl:col-span-3 xl:mb-0">
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>First Name</mat-label>
                                <input
                                    title="First Name"
                                    matInput
                                    formControlName="firstName"
                                    maxLength="20"
                                    [appRegexInput]="
                                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                                    "
                                />
                            </mat-form-field>
                        </div>

                        <div
                            class="w-full xl:col-span-3 2xl:col-span-2 xl:mb-0"
                        >
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>Middle Initial</mat-label>
                                <input
                                    title="Middle Initial"
                                    matInput
                                    formControlName="middleInitial"
                                    maxLength="1"
                                    [appRegexInput]="
                                        regExPattern.AlphabeticalCharacters
                                    "
                                />
                            </mat-form-field>
                        </div>

                        <div class="w-full xl:col-span-3 xl:mb-0">
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>Last Name</mat-label>
                                <input
                                    title="Last Name"
                                    matInput
                                    formControlName="lastName"
                                    maxLength="20"
                                    [appRegexInput]="
                                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                                    "
                                />
                            </mat-form-field>
                        </div>

                        <div
                            class="w-full xl:col-span-3 2xl:col-span-2 xl:mb-0"
                        >
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>Suffix</mat-label>
                                <input
                                    title="Suffix"
                                    matInput
                                    formControlName="suffix"
                                    maxLength="3"
                                    [appRegexInput]="
                                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                                    "
                                />
                            </mat-form-field>
                        </div>
                    </div>
                } @else {
                    <div class="w-full xl:w-6/12">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Entity Type</mat-label>
                            <mat-select formControlName="entityType">
                                @for (
                                    option of entityTypeOptions;
                                    track option.value
                                ) {
                                    <mat-option [value]="option.value">
                                        {{ option.label }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="w-full xl:w-6/12">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Business Entity Type</mat-label>
                            <mat-select formControlName="businessEntityType">
                                @for (
                                    option of businessEntityTypeOptions;
                                    track option.value
                                ) {
                                    <mat-option [value]="option.value">
                                        {{ option.label }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="w-full xl:w-6/12">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Business Entity Name</mat-label>
                            <input
                                matInput
                                formControlName="businessEntityName"
                                [appRegexInput]="
                                    regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                                "
                            />
                        </mat-form-field>
                    </div>
                }

                <div class="w-full xl:w-6/12">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>
                            Taxpayer Id Number / Social Security Number
                        </mat-label>
                        <input
                            matInput
                            type="text"
                            [formControl]="
                                form.controls.taxpayerIdentificationNumber
                            "
                            [appRegexInput]="regExPattern.NumericOnly"
                            maxlength="9"
                        />
                    </mat-form-field>
                </div>

                <div class="w-full xl:w-6/12">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>
                            Taxpayer Id Number Exception Reason Code
                        </mat-label>
                        <mat-select
                            [formControl]="
                                form.controls.taxpayerIdExceptionReasonCode
                            "
                        >
                            @for (
                                option of taxpayerIdExceptionReasonOptions;
                                track option.value
                            ) {
                                <mat-option [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title
                    class="!text-tertiary-900 font-normal text-xl py-2"
                >
                    <h3 class="!text-tertiary-900 font-normal !text-xl !m-0">
                        Representative Contact Information &amp; Signature
                    </h3>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <hr class="mb-4" />
            <div
                class="flex flex-col w-full pl-4 md:pl-8 xl:w-10/12 2xl:w-8/12"
            >
                <div class="w-full xl:w-6/12">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Contact Rep. Position/Title</mat-label>
                        <input
                            matInput
                            [formControl]="
                                form.controls.contactRepresentativeTitle
                            "
                            title="Contact Rep. Position/Title"
                            maxlength="80"
                            [appRegexInput]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                        />
                    </mat-form-field>
                </div>

                <div
                    class="w-full flex flex-wrap xl:space-y-0 xl:grid xl:grid-cols-12 xl:gap-4"
                >
                    <div class="w-full xl:col-span-3 xl:mb-0">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>First Name</mat-label>
                            <input
                                matInput
                                [formControl]="
                                    form.controls.contactRepresentativeFirstName
                                "
                                title="Representative First Name"
                                maxLength="20"
                                [appRegexInput]="
                                    regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                                "
                            />
                        </mat-form-field>
                    </div>

                    <div class="w-full xl:col-span-2 xl:mb-0">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Middle Initial</mat-label>
                            <input
                                matInput
                                [formControl]="
                                    form.controls
                                        .contactRepresentativeMiddleInitial
                                "
                                title="Representative Middle Initial"
                                maxLength="1"
                                [appRegexInput]="
                                    regExPattern.AlphabeticalCharacters
                                "
                            />
                        </mat-form-field>
                    </div>

                    <div class="w-full xl:col-span-3 xl:mb-0">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Last Name</mat-label>
                            <input
                                matInput
                                [formControl]="
                                    form.controls.contactRepresentativeLastName
                                "
                                title="Representative Last Name"
                                maxLength="20"
                                [appRegexInput]="
                                    regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                                "
                            />
                        </mat-form-field>
                    </div>
                </div>

                <div class="w-full flex flex-col xl:flex-row xl:items-center">
                    <div class="w-full xl:w-1/3">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>Street Address</mat-label>
                            <input
                                matInput
                                [formControl]="
                                    form.controls
                                        .contactRepresentativeStreetAddress
                                "
                                title="Street Address"
                                maxlength="60"
                                [appRegexInput]="
                                    regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                                "
                            />
                        </mat-form-field>
                    </div>

                    <div
                        class="flex items-center justify-center xl:my-0 xl:mx-3 xl:mb-4"
                        aria-label="or"
                    >
                        <span class="text-tertiary-600">Or</span>
                    </div>

                    <div class="w-full xl:w-1/3">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>PO Box</mat-label>
                            <input
                                matInput
                                [formControl]="
                                    form.controls.contactRepresentativePoBox
                                "
                                title="PO Box"
                                maxlength="20"
                                [appRegexInput]="
                                    regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                                "
                            />
                        </mat-form-field>
                    </div>
                </div>

                <div
                    class="w-full flex flex-wrap xl:space-y-0 xl:grid xl:grid-cols-12 xl:gap-4"
                >
                    <div class="w-full xl:col-span-4 xl:mb-0">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>City</mat-label>
                            <input
                                matInput
                                [formControl]="
                                    form.controls.contactRepresentativeCity
                                "
                                title="City"
                                [appRegexInput]="
                                    regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                                "
                                maxLength="20"
                            />
                        </mat-form-field>
                    </div>

                    <div class="w-full xl:col-span-2 xl:mb-0">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>State</mat-label>
                            <mat-select
                                [formControl]="
                                    form.controls.contactRepresentativeState
                                "
                            >
                                @for (
                                    state of stateOptions;
                                    track state.value
                                ) {
                                    <mat-option [value]="state.value">
                                        {{ state.label }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="w-full xl:col-span-2 xl:mb-0">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>ZIP Code</mat-label>
                            <input
                                matInput
                                [formControl]="
                                    form.controls.contactRepresentativeZipCode
                                "
                                title="ZIP Code"
                                [imask]="maskOptions.postalCode"
                                [unmask]="true"
                                [pattern]="regExPattern.PostalCode"
                            />
                        </mat-form-field>
                    </div>
                </div>

                <div class="w-full xl:w-6/12">
                    <app-phone-number-input
                        label="Contact Rep Phone Number"
                        title="Contact Rep Phone Number"
                        [control]="form.controls.contactRepresentativePhone"
                        [withExtension]="false"
                    >
                    </app-phone-number-input>
                </div>

                <div class="w-full xl:w-6/12">
                    <app-phone-number-input
                        label="Contact Rep Fax Number"
                        title="Contact Rep Fax Number"
                        [control]="form.controls.contactRepresentativeFax"
                        [withExtension]="false"
                    >
                    </app-phone-number-input>
                </div>

                <div class="w-full xl:w-6/12">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Contact Rep Email Address</mat-label>
                        <input
                            matInput
                            [formControl]="
                                form.controls.contactRepresentativeEmail
                            "
                            title="Contact Rep Email Address"
                            [pattern]="regExPattern.EmailAddress"
                            maxlength="50"
                        />
                    </mat-form-field>
                </div>

                <div class="w-full xl:w-6/12">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Signature</mat-label>
                        <input
                            matInput
                            [formControl]="form.controls.applicantSignature"
                            title="Signature"
                            maxlength="40"
                            [appRegexInput]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                        />
                    </mat-form-field>
                </div>

                <div class="w-full xl:w-6/12">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Date</mat-label>
                        <input
                            matInput
                            [matDatepicker]="repDatePicker"
                            [formControl]="form.controls.signatureDate"
                            autocomplete="off"
                        />
                        <mat-datepicker-toggle
                            matIconSuffix
                            [for]="repDatePicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #repDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title
                    class="!text-tertiary-900 font-normal text-xl py-2"
                >
                    <div class="flex items-center">
                        <h3
                            class="!text-tertiary-900 font-normal !text-xl !m-0"
                        >
                            Security Information - Not Currently Required by FCC
                        </h3>
                        <app-hover-tooltip
                            class="ml-2"
                            [message]="'The FCC does not presently require EWA to collect or provide your security information. The fields herein may be required in the future.'"
                        ></app-hover-tooltip>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <hr class="mb-4" />
            <div
                class="flex flex-col w-full pl-4 md:pl-8 xl:w-10/12 2xl:w-8/12"
            >
                <div class="w-full xl:w-6/12">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Password</mat-label>
                        <input
                            matInput
                            type="password"
                            [formControl]="form.controls.password"
                            title="Password"
                            autocomplete="new-password"
                            minlength="8"
                            maxlength="64"
                        />
                    </mat-form-field>
                </div>

                <div class="w-full xl:w-6/12">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Confirm Password</mat-label>
                        <input
                            matInput
                            type="password"
                            [formControl]="form.controls.confirmPassword"
                            title="Confirm Password"
                            autocomplete="new-password"
                            maxlength="64"
                        />
                        @if (
                            form.controls.confirmPassword.hasError(
                                'passwordMismatch'
                            ) &&
                            (form.controls.confirmPassword.touched ||
                                form.controls.confirmPassword.dirty)
                        ) {
                            <mat-error>Passwords do not match.</mat-error>
                        }
                    </mat-form-field>
                </div>

                <div class="w-full xl:w-6/12">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Personal Security Question</mat-label>
                        <mat-select
                            [formControl]="form.controls.securityQuestion"
                        >
                            @for (
                                option of securityQuestionOptions;
                                track option.value
                            ) {
                                <mat-option [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="w-full xl:w-6/12">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Personal Security Question Answer</mat-label>
                        <input
                            matInput
                            [formControl]="form.controls.securityQuestionAnswer"
                            title="Personal Security Question Answer"
                        />
                    </mat-form-field>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</form>
